import { setupLazyLoad } from './lazy-load.ts';
import { setupSearch } from './search.ts';
import { setupToggles } from './toggles.ts';

import { setupAnchorLinks } from './anchor-links.ts';
import { setupFooterNav } from './footernav.ts';
import { setupMenu } from './menu.ts';
export function setup() {
  setupToggles();
  setupSearch();
  setupLazyLoad();
  setupFooterNav();
  setupMenu();
  setupAnchorLinks();
}
